import { NavLink } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Company */}
        <div className="footer-section footer-about">
          <h2>SHREE BRAINS</h2>
          <p>
            We provide E-commerce Solutions, Order Management Systems,
            SMS, Email, WhatsApp Business API, and Business Automation
            services to help businesses grow digitally.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3>Quick Links</h3>

          <ul>
            <li>
              <NavLink to="/">Home</NavLink>
            </li>

            <li>
              <NavLink to="/about">About</NavLink>
            </li>

            <li>
              <NavLink to="/services">Services</NavLink>
            </li>

            <li>
              <NavLink to="/contact">Contact</NavLink>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-section">
          <h3>Contact Us</h3>

          <p>📍 New Delhi, India</p>

          <p>
            📧{" "}
            <a href="mailto:info@shreebrains.com">
              info@shreebrains.com
            </a>
          </p>

          <p>
            📞{" "}
            <a href="tel:+919971815737">
              +91 99718 15737
            </a>
          </p>
        </div>

      </div>

      {/* Bottom Footer */}
      <div className="footer-bottom">

        <div className="footer-legal-links">
          <NavLink to="/terms-and-conditions">
            Terms & Conditions
          </NavLink>

          <span>|</span>

          <NavLink to="/privacy-policy">
            Privacy Policy
          </NavLink>
        </div>

        <p>
          © {new Date().getFullYear()} SHREE BRAINS. All Rights Reserved.
        </p>

      </div>
    </footer>
  );
};

export default Footer;